// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".luna-notification{$po:fixed;$t:0;$l:0;$w:100%;$h:100%;$p:20px;$bsi:border-box;$pe:none;$d:flex;flex-direction:column;$fs:14px}.luna-notification-item{$d:flex;$bs:0 3px 7px 0 rgba(0,0,0,.25);$p:10px 16px;$b:#fff}.luna-notification-lower{$mt:16px}.luna-notification-upper{$mb:16px}", ""]);
// Exports
module.exports = exports;
